import { createStore } from 'vuex';

const store = createStore({
    state() {
        return {
            fontSize: 12,
            provider: {},
            userInfo: {},
            isLoginNeed: true,
            isMobile: true,
            // Hospital Info
            hospitalName: '병원',

            // Components
            components: [ 'CarouselBullets', 'TapMenuUnderline', 'MenuG', 'BannerAd' ],
            activeComponents: [ 'CarouselBullets', 'TapMenuUnderline', 'MenuG', 'BannerAd' ],

            // Top Bar
            topBarBackgroundColor: '',
            topMenuPosition: 'right',
            topTextPosition: 'center',

            // Carousel
            autoPlay: '10000',
            imageGap: 1,

            // Tap Menu
            tapMenu: [
                { name: '외래', type: 'outpatient' },
                { name: '입원', type: 'admission' },
                { name: '응급', type: 'emergency' },
                { name: 'MY', type: 'my' }
            ],
            selectedTapMenu: [ 
                { name: '외래', type: 'outpatient' },
                { name: '입원', type: 'admission' }, 
            ],
            tapMenuPosition: 'flex-start',
            tapMenuPadding: 8,

            defaultMenuPadding: 8,



            // Banner
            bannerPadding: 0,
            bannerRadius: 10,
            autoPlayBanner: 3000,

        
            // Footer
            hospitalFooterInfo: ' 주소 : 경기도 수원시 팔달구 경수대로 437 \n 대표전화 : 1577-8382 ｜ 팩스 : 031-223-2322 \n 대표자 : 김철수 사업자등록번호 : 419-82-00103 \n ⓒWILTSE MEMORIAL HOSPITAL',
            footerColour: [
                { name: 'White', colour: '#ffffff' },
                { name: 'Gray', colour: '#F0F0F0' },
                { name: 'Red', colour: '#BE4141' }
            ],
            footerPosition: 'flex-start',
            footerBackgroundColour: { name: 'Blue', colour: '#CDE1F0' },


            // Admin Page
            themeColour: [
                { name: 'Red', colour: '#BE4141'},
                { name: 'Orange', colour: '#E1823C' },
                { name: 'Green', colour: '#4B9669' },
                { name: 'Blue', colour: '#007DE1' },
                { name: 'Navy', colour: '#3C5A91' },
                { name: 'Purple', colour: '#6455A5' },
            ],
            // Preview Mobile
            activeThemeColour: { name: 'Red', colour: '#BE4141'},


            // Home Page Menu
            myMenu: [
                { name: '가지고 와지나' }
            ],
            theme: {
                isLoad: false,
                color: "red",
                font: "pretendard"
            }

        }
    },

    mutations :{
        // Customise 
        setProvider(state, payload){ state.provider = payload },
        setUserInfo(state, payload){ state.userInfo = payload },
        setIsLoginNeed(state, payload){ state.isLoginNeed = payload },
        setIsMobile(state, payload){ state.isMobile = payload },
        setHospitalName(state, payload){ state.hospitalName = payload },
        setTheme(state, payload){ state.theme = payload },

        // Components
        setSelectedComponent(state, payload) {
            state.activeComponents = payload
        },

        // Top Bar
        setTopMenuPosition(state, payload) {
            state.topMenuPosition = payload;
        },
        setTopTextPosition(state, payload) {
            state.topTextPosition = payload;
        },

        // Carousel
        setAutoPlay(state, payload) {
            state.autoPlay = payload;
        },
        setImageGap(state, payload) {
            state.imageGap = payload;
        },

        // TapMenu
        setSelectedTapMenu(state, payload) {
            state.selectedTapMenu = payload
        },
        setTapMenuPosition(state, payload) {
            state.tapMenuPosition = payload
        },
        setTapMenuPadding(state, payload) {
            state.tapMenuPadding = payload
        },


        // Banner
        setBannerPadding(state, payload) {
            state.bannerPadding = payload;
        },
        setBannerRadius(state, payload) {
            state.bannerRadius = payload;
        },
        setAutoPlayBanner(state, payload) {
            state.autoPlayBanner = payload;
        },


        // Footer
        setFooterInfo(state, payload) {
            state.hospitalFooterInfo = payload
        },
        setFooterPosition(state, payload) {
            state.footerPosition = payload;
        },
        setFooterBackground(state, payload) {
            state.footerBackgroundColour = payload;
        },


        // Preview Mobile
        setActiveThemeColour(state, payload) {
            state.activeThemeColour = payload;
        },
     },
    
})



export default store;